import React from 'react';
import { Grid } from '@mui/material';
import { ReactSelect } from 'components/form/field/react_select';
import { connect, useDispatch } from 'react-redux';
import { compose } from 'recompose';
import { updateNoteBar as unb } from 'actions/action-notes';

const TherapyDropDownSelector = ({
  classes,
  id = 'target_therapy_selector',
  therapyOptions,
  selected_therapies,
  selectorText = 'Select target therapies',
  setSelectedTherapies,
}: any) => {
  const dispatch = useDispatch();
  const updateNoteBar = (...args: any): any => dispatch(unb(...args));
  const updaterFunction = setSelectedTherapies || updateNoteBar;
  return (
    <Grid item xs={12} className={classes.noteDisplay}>
      <ReactSelect
        name="target_therapies"
        label={
          <div
            style={{
              fontSize: '15px',
              marginTop: '10px',
              marginBottom: '5px',
              fontWeight: 'bold',
            }}
          >
            {selectorText}
          </div>
        }
        classes={classes.reactSelect}
        value={selected_therapies}
        handleOnChange={(options: { value: number; label: string }[]) => {
          let newSelection = options;
          if (options.length === 0) {
            newSelection = [{ value: -1, label: 'All Therapies in the Order' }];
            return updaterFunction({ selected_therapies: newSelection });
          }
          if (newSelection.length > 1 && newSelection.some(option => option.value === -1)) {
            newSelection = newSelection.filter(option => option.value !== -1);
          }
          return updaterFunction({ selected_therapies: newSelection });
        }}
        fields={therapyOptions}
        isMulti
        isClearable
        style={{
          menu: (base: any) => ({
            ...base,
            zIndex: 1330,
          }),
        }}
        id={id}
      />
    </Grid>
  );
};

function mapStateToProps(state: any, ownProps: any) {
  const { noteBar } = state;
  const therapy_ids = ownProps.therapy_ids || noteBar.therapy_ids || [];
  const selected_therapies = ownProps.selected_therapies || noteBar.selected_therapies || [];
  const existingTherapies = Object.values(state.therapies?.data || {});
  const therapyOptions = Object.values(existingTherapies || {})
    .filter((therapy: any) => therapy_ids.includes(therapy.id))
    .reduce((acc: any, therapy: any) => {
      if (!acc.some((option: any) => option.value === therapy.id)) {
        acc.push({
          value: therapy.id,
          label: `${therapy.drug_name} ${therapy.strength} ${therapy.strength_unit_of_measure} ${therapy.dosage_form}`,
        });
      }
      return acc;
    }, []);

  return {
    therapyOptions,
    selected_therapies,
  };
}

export default compose(connect(mapStateToProps))(TherapyDropDownSelector);
